'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

var _bFooterELink = (require('./__link/footer__link.react.js').default || require('./__link/footer__link.react.js')).applyDecls();

var _bFooterELink2 = _interopRequireDefault(_bFooterELink);

var _bCopyright = (require('./../copyright/copyright.react.js').default || require('./../copyright/copyright.react.js')).applyDecls();

var _bCopyright2 = _interopRequireDefault(_bCopyright);

var _eColumnMSideRight = (require('./__column/footer__column.react.js').default || require('./__column/footer__column.react.js')).applyDecls();

var _eColumnMSideRight2 = _interopRequireDefault(_eColumnMSideRight);

var _bIServices = (require('./../i-services/i-services.react.js').default || require('./../i-services/i-services.react.js')).applyDecls();

var _bIServices2 = _interopRequireDefault(_bIServices);

void 0;

var _bFooterTI18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./footer.i18n/ru'))('footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./footer.i18n/en'))('footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./footer.i18n/be'))('footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./footer.i18n/id'))('footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./footer.i18n/kk'))('footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./footer.i18n/tr'))('footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./footer.i18n/tt'))('footer');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./footer.i18n/uk'))('footer');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
    }

    return function () {};
}();

var _bFooterTI18n2 = _interopRequireDefault(_bFooterTI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'footer',
    mix: { block: 'clearfix' },
    attrs: function attrs(_ref) {
        var role = _ref.role;

        return {
            role: role
        };
    },
    content: function content(_ref2, children) {
        var tld = _ref2.tld,
            region = _ref2.region,
            statUrl = _ref2.statUrl,
            start = _ref2.start;

        if (children) {
            return children;
        }

        var leftColumnContent = [];
        var rightColumnContent = [];
        var services = {
            mobile: _bIServices2.default.serviceUrl('mobile', region),
            advertising: _bIServices2.default.serviceUrl('advertising', region),
            company: _bIServices2.default.serviceUrl('company', region),
            legal: _bIServices2.default.serviceUrl('legal', region)
        };

        leftColumnContent.push(_react2.default.createElement(
            _bFooterELink2.default,
            { key: 'mobile-apps', url: services.mobile },
            (0, _bFooterTI18n2.default)('apps')
        ));

        var isKubr = tld.indexOf('com') === -1;

        isKubr && rightColumnContent.push(_react2.default.createElement(
            _bFooterELink2.default,
            { key: 'adv', url: services.advertising },
            (0, _bFooterTI18n2.default)('advert')
        ));

        isKubr && statUrl && rightColumnContent.push(_react2.default.createElement(
            _bFooterELink2.default,
            { key: 'stat', url: statUrl },
            (0, _bFooterTI18n2.default)('stat')
        ));

        rightColumnContent.push(_react2.default.createElement(
            _bFooterELink2.default,
            { key: 'terms', url: services.legal + '/termsofuse' },
            (0, _bFooterTI18n2.default)('termsofuse')
        ));

        rightColumnContent.push(_react2.default.createElement(
            _bFooterELink2.default,
            { key: 'about', url: services.company },
            (0, _bFooterTI18n2.default)('about')
        ));

        rightColumnContent.push(_react2.default.createElement(_bCopyright2.default, { key: 'copyright', contentRegion: region,
            elemLinkMix: { block: this.block, elem: 'link' }, start: start }));

        return [_react2.default.createElement(
            _eColumnMSideRight2.default,
            { key: 'column1' },
            leftColumnContent
        ), _react2.default.createElement(
            _eColumnMSideRight2.default,
            { key: 'column2', side: 'right' },
            rightColumnContent
        )];
    }
}, {
    Link: _bFooterELink2.default,
    Column: _eColumnMSideRight2.default,
    propTypes: {
        region: _propTypes2.default.string.isRequired,
        tld: _propTypes2.default.string.isRequired,
        start: _propTypes2.default.string,
        statUrl: _propTypes2.default.string
    }
});